module.exports = __webpack_public_path__ + "img/Routing & Switching.6cfa07dd.svg";